import { clientDangerouslyAllocate, EXPERIMENT_TYPE } from '@fiverr-private/experiments';
import { VIDEO_STRIP, VIDEO_STRIP_EXPERIMENT } from '../../../GigCards/Components/constants';

export function calcVideoStripRow(gigs: any[], bannersExist: boolean): number {
    const FALLBACK_ROW = 5;
    const GIGS_IN_ROW = 4;
    const BANNER_ROW = 3;
    const firstVideoIndex = gigs.findIndex((gig) => gig.type === VIDEO_STRIP);
    const videoStripRow = Math.max(1, Math.floor(firstVideoIndex / GIGS_IN_ROW)) + 1;

    // because of a bug banners exist, but they are not displayed. making the video strip look like it's in row 3
    // fixing by moving it to row 5
    if (bannersExist && (videoStripRow === BANNER_ROW || videoStripRow === BANNER_ROW + 1)) {
        return FALLBACK_ROW;
    }

    return videoStripRow;
}

export function onVideoStripPositionVisible(clientExperimentsGroups: any): void {
    const experimentGroup = Number(clientExperimentsGroups[VIDEO_STRIP_EXPERIMENT]);

    if ([1, 2].includes(experimentGroup)) {
        clientDangerouslyAllocate({
            experimentId: VIDEO_STRIP_EXPERIMENT,
            experimentType: EXPERIMENT_TYPE.GUEST,
            group: experimentGroup,
        });
    }
}
